import { render } from "./MoreInfoView.vue?vue&type=template&id=6ee3f378"
import script from "./MoreInfoView.vue?vue&type=script&lang=js"
export * from "./MoreInfoView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__